import React, { useEffect } from "react";
import styles from './styles.module.css';
import { useLocation } from "react-router-dom";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch } from "react-redux";
import { ROUTES_CONST } from "../../utils/constants";



const About = () => {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);


  return (
    <main className='main'>
      <h1 className="title">{title}</h1>
      <div className={styles.container}>
        <p className={styles.text}>&emsp;&emsp;
          Наша компания - коллектив специалистов, сосредоточенных на достижении
          высоких результатов в своей области.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Мы стремимся к тому, чтобы предоставлять высококачественные услуги/продукты,
          которые полностью удовлетворяют потребности наших клиентов.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Наша деятельность охватывает широкий спектр услуг/продуктов, включая...
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Наша команда обладает обширным опытом в своей области, каждый из нас является
          профессионалом в своем деле.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Мы ценим профессионализм, инновации и клиентоориентированность.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Наша компания выделяется своим индивидуальным подходом к каждому клиенту и
          стремлением к постоянному совершенствованию.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Мы гордимся нашими достижениями в области...
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Мы стремимся к долгосрочным партнерским отношениям, основанным на взаимном
          доверии и понимании.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Мы успешно реализовали ряд проектов, которые подтверждают нашу экспертизу и
          профессионализм.
        </p>
        <p className={styles.text}>&emsp;&emsp;
          Связаться с нами можно через различные каналы: по телефону, по электронной почте
          или в наших социальных сетях.
        </p>
      </div>
    </main>
  );
};

export default About;
